import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';
import { OptionsAssetIcon } from './OptionsAssetIcon';
import { formatEquivalentDelta, getPortfolioRoleBadgeMeta, getPortfolioRoleLabel } from './optionsPortfolioActivityUtils';

export const OptionsCampaignManagementSection = ({ activities = [], testIdPrefix = 'options-campaign-management' }) => {
  const { t } = useOptionsLocale();
  if (!activities.length) return null;

  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-section`}>
      <div className="space-y-1" data-testid={`${testIdPrefix}-header`}>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-white/45">{t('history.managementActivitiesTitle')}</p>
        <p className="text-sm text-white/55">{t('history.managementActivitiesDescription')}</p>
      </div>

      <div className="space-y-3" data-testid={`${testIdPrefix}-list`}>
        {activities.map((item, index) => {
          const badge = getPortfolioRoleBadgeMeta(item?.effective_role);
          return (
            <div key={item.id} className="rounded-2xl border border-white/10 bg-black/20 px-4 py-4" data-testid={`${testIdPrefix}-item-${index}`}>
              <div className="flex flex-wrap items-center gap-2">
                <Badge className={badge.className} data-testid={`${testIdPrefix}-role-${index}`}>{getPortfolioRoleLabel(item?.effective_role, t)}</Badge>
                <Badge className="border-white/10 bg-white/[0.05] text-white/75" data-testid={`${testIdPrefix}-instrument-type-${index}`}>{item?.instrument_type}</Badge>
              </div>
              <div className="mt-3 flex items-center gap-2">
                <OptionsAssetIcon assetKey={item?.underlying || item?.base_currency} size={16} />
                <p className="text-sm font-semibold text-white" data-testid={`${testIdPrefix}-title-${index}`}>{item?.instrument_name}</p>
              </div>
              <p className="mt-2 text-xs text-white/55" data-testid={`${testIdPrefix}-meta-${index}`}>{t('history.activityDeltaLine', { delta: formatEquivalentDelta(item?.delta_equivalent, item?.underlying) })}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OptionsCampaignManagementSection;